<template>
  <div>
    <van-nav-bar title="邻友惠" fixed />
    <div style="height:46px"></div>
    <vue-swpier :items="slide" autoplay="5000"></vue-swpier>
    <div>
      <van-cell-group>
        <van-cell title="小区名称：" :value="community.name" />
        <van-cell title="位置：" :value="community.address"  />
        <van-cell title="开发商：" :value="community.developers"  />
        <van-cell title="绿化率：" :value="community.greening_rate"  />
        <van-cell title="物业公司：" :value="community.property"  />
        <van-cell title="物业类型：" :value="community.property_type"  />
         <van-cell title="商圈：" :value="community.shangquan"  />
      </van-cell-group>
    </div>
    <div style="height:64px"></div>
    <TabBar active="1" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import vueSwpier from "@/components/vueSwiper.vue";
import Vue from "vue";
import { Cell, CellGroup } from "vant";

Vue.use(Cell);
Vue.use(CellGroup);
export default {
  name: "index",
  components: {
    TabBar,
    vueSwpier
  },
  data() {
    return {
      slide: [],
      community: {}
    };
  },
  methods: {
    getSlide(id) {
      this.$http
        .get(this.GLOBAL.API + "s_slide/index/slide?id=" + id, {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.slide = data.data;
          }
        });
    },
    getCommunity() {
      this.$http
        .get(this.GLOBAL.API + "/s_community/home/community", {
          params: { id: JSON.parse(localStorage.getItem("community")).id },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.community = data.data;
          }else{
              this.$toast(data.msg);
          }
        });
    }
  },
  mounted() {
    this.getSlide(5);
    this.getCommunity();
  }
};
</script>
<style lang="scss" scoped>
.van-cell__title{text-align: left;}

</style>